export enum TanglMessageEnum {
    Click,
    SetPosition,
    AddOnScene,
    RemoveFromScene,
    ZoomCamera,
    ToolChanged,
}
